<template>
  <span class="row">
    <dt class="col-5">{{field}}</dt>
    <dd v-if="!clickable" class="col-7">{{value | isEmpty}}</dd>
    <dd v-else class="col-7" @click="onClick"><a href="#">{{value | isEmpty}}</a></dd>
  </span>
</template>
<script type="text/javascript">
export default {
  name: 'ServiceRequestDetailRow',
  props: {
    field: String,
    value: [String, Number],
    clickable:{
    	type:Boolean,
    	default:false,
    },
  },
  methods:{
  	onClick(){
  		this.$emit('click',true);
  	}
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestDetailRow.vue